/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import Skeleton from "react-loading-skeleton";

/* Helpers, constants, custom methods, internal libraries */

/* Components */

/* Styles */
import styles from "./styles.js";

const AirlineProgramsTabSkeleton = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.skeletonWrapper}>
      {Array.from({ length: 3 }).map((_, i) => {
        return (
          <div className={classes.cardSkeletonWrapper} key={i}>
            <Skeleton height={80} className={classes.shortSk} />
          </div>
        );
      })}
    </div>
  );
};

export default AirlineProgramsTabSkeleton;
